<template>
  <div class="workspace">
    <div ref="result"></div>
    <div class="section-heading">
      <h2>Account Settings</h2>

      <label class="remove al-button" @click="$router.push('/users')">
        <i class="fas fa-check"></i> Done
      </label>
    </div>
    <div class="flex-area" v-if="activeUserInfo">
      <div id="user-settings" class="setting-box" v-if="!refresh1">
        <div class="setting-heading">
          <h2>User Profile</h2>
          <p>You can manage your own contact details and update your password.</p>
        </div>
        <div class="setting-section">
          <div class="s-row">
            <div class="s-column"> <label class="al-label">
              First Name
              <input class="al-input" type="text" v-model="name" :placeholder="activeUserInfo.name" />
            </label></div>
            <div class="s-column"><label class="al-label">
              Last Name
              <input class="al-input"  v-model="lastname" type="text" :placeholder="activeUserInfo.lastname" />
            </label></div>
          </div>

          <div class="s-row">
            <div class="s-column"><label class="al-label">
              Email
              <input class="al-input" type="email" v-model="email" :placeholder="activeUserInfo.email" />
            </label></div>
            <div class="s-column"><label class="al-label">
              Phone Number
              <input class="al-input"
                     type="tel"
                     autocomplete="chrome-off"
                     v-model="phone"
                     :placeholder="activeUserInfo.phone" />
            </label></div>
          </div>
        </div>
        <div class="setting-heading" v-if="false">
          <h2>Password</h2>
          <div class="setting-section">
            <label class="al-label">
              Current Password
              <input class="al-input" v-model="old_pwd"
                     autocomplete="chrome-off"
                     type="password" placeholder="Type your current password" />
            </label>
            <div class="s-row">
              <div class="s-column"><label class="al-label">
                New Password
                <input class="al-input" type="password"
                       v-model="new_pwd"
                       autocomplete="chrome-off"
                       v-validate="{ required: new_pwd !== '', min: 10, regex: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).*$/ }"
                       placeholder="Enter new password" />
              </label></div>
              <div class="s-column"><label class="al-label">
                Confirm New Password
                <input class="al-input" type="password"
                       v-model="new_pwd2"
                       v-validate="{ required: new_pwd !== '', min: 10, regex: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).*$/ }"
                       placeholder="Confirm new password" />
              </label></div>
            </div>

            <div class="forgot-pass"><a href="/reset-password">Forgot Password?</a></div>
          </div>
        </div>
        <div class="al-button blue-button" @click.prevent="submitForm">Update Profile</div>
      </div>

      <div id="billing-settings" class="setting-box" v-if="!refresh3">
        <div class="setting-heading">
          <h2>Billing Address</h2>
          <p>You can manage your billing address here.</p>
          <br/>
        </div>
        <div class="setting-section" >
          <div class="company-detail">
            <div class="s-row">
              <div class="s-column"><label class="al-label">
                Street
                <places :location="billing_street" :found="placesFoundBilling" class="w-full"></places>
              </label></div>
              <div class="s-column"><label class="al-label">
                Unit
                <input class="al-input" v-model="billing_unit" type="text" placeholder="Unit, Apartment # etc." />
              </label></div>
            </div>
            <div class="s-row billing">
              <div class="s-column">
                <label class="al-label">
                  City
                  <input class="al-input" type="text" v-model="billing_city" placeholder="City" />
                </label>
              </div>
              <div class="s-column">
                <label class="al-label">
                  State
                  <input class="al-input" type="text" v-model="billing_state" placeholder="State" />
                </label>
              </div>
              <div class="s-column">
                <label class="al-label">
                  Zipcode
                  <input class="al-input" type="text" placeholder="Zip Code"  v-model="billing_zipcode"/>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="al-button blue-button" @click="updateBillingSettings">Update Settings</div>
      </div>
      <div id="company-settings" class="setting-box" v-if="!refresh2">
        <div class="setting-heading">
          <h2>Company</h2>
          <p>You can manage your business information here.</p>
          <br/>
        </div>
        <div class="setting-section" >
          <div class="company-detail">
            <div class="s-row">
              <div class="s-column">
                <div class="al-label">
                Company Logo
                <upload-image :required="this.company_logo === ''"
                              :img_id="(this.company_logo === '') ? null : this.company_logo"
                              :code="'campaign-image'" :index="-1"
                              :callback="companyLogoUploaded" />
                </div>
              </div>
            </div>

            <div class="s-row">
              <div class="s-column">
                <label class="al-label">
                  Company Name
                  <input class="al-input" type="text" v-model="company_name" placeholder="Company Name" />
                </label>
              </div>
              <div class="s-column">
                <label class="al-label">
                Industry
                <company-industary-select v-if="!refreshIndustry" :changed="industryChanged" :selected_val="industry"></company-industary-select>
              </label>
              </div>
            </div>
            <div class="s-row">
              <div class="s-column"><label class="al-label">
                Address 1
                <places :location="address_line1" :found="placesFound" class="w-full"></places>
              </label></div>
              <div class="s-column"><label class="al-label">
                Address 2
                <input class="al-input" type="text" v-model="address_line2" placeholder="Address line 2" />
              </label></div>
            </div>
            <div class="s-row">
              <div class="s-column"><label class="al-label">
                City
                <input class="al-input" v-model="city" type="text" placeholder="City" />
              </label></div>
              <div class="s-column"><label class="al-label">
                State/County/Region
                <input class="al-input" type="text" placeholder="State"  v-model="state"/>
              </label></div>
            </div>
            <div class="s-row">
              <div class="s-column"><label class="al-label">
                ZIP/Postcode
                <input class="al-input" type="text" v-model="zipcode" placeholder="11111" />
              </label></div>
              <div class="s-column"></div>
            </div>
            <div class="s-row">
              <div class="s-column"><label class="al-label">
                Website URL
                <input class="al-input" type="text" placeholder="example.com" v-model="website" />
              </label></div>
              <div class="s-column"><label class="al-label">
                Contact Phone Number
                <input class="al-input" type="text" placeholder="+1501293124" v-model="company_phone" />
              </label></div>
            </div>
          </div>
        </div>
        <div class="al-button blue-button" @click="updateCompanySettings">Update Settings</div>
      </div>

    </div>

  </div>
</template>
<script>

import UploadImage from '../layouts/components/navbar/UploadImage'
import Places from '../components/places/Places'
import CompanyIndustarySelect from './pages/Settings/CompanyIndustarySelect'
export default {
  props: {
    id: {
      type: String
    }
  },
  data () {
    return {
      activeUserInfo: null,
      refresh1: false,
      refresh2: false,
      refresh3: false,
      refreshIndustry: false,
      industry: '',
      name: '',
      email: '',
      old_pwd: '',
      new_pwd: '',
      new_pwd2: '',
      google_places: '',
      lastname: '',
      phone: '',
      company_logo: '',
      company_name: '',
      vat_number: '12345',
      address_line1: '',
      address_line2: '',
      city: '',
      state: '',
      zipcode: '',
      website: '',
      company_phone: '',
      location: null,
      placeService: null,
      billing_street: '',
      billing_unit: '',
      billing_zipcode: '',
      billing_state: '',
      billing_city: ''
    }
  },
  metaInfo () {
    return {
      title: 'Edit User Settings',
      titleTemplate: '%s - AuthorizeLocal',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Manage your company settings'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'Local SEO Solutions'
        }
      ]
    }
  },
  components: {
    Places,
    UploadImage,
    CompanyIndustarySelect
  },
  mounted () {
    this.placeService = new window.google.maps.places.PlacesService(this.$refs.result)
    this.getUser()
  },
  watch: {
    refresh1 () {
      if (this.refresh1) {
        setTimeout(() => {
          this.refresh1 = false
        }, 500)
      }
    },
    refreshIndustry () {
      if (this.refreshIndustry) {
        setTimeout(() => {
          this.refreshIndustry = false
        }, 500)
      }
    },
    refresh2 () {
      if (this.refresh2) {
        setTimeout(() => {
          this.refresh2 = false
        }, 500)
      }
    },
    refresh3 () {
      if (this.refresh3) {
        setTimeout(() => {
          this.refresh3 = false
        }, 500)
      }
    }
  },
  computed: {
    currenUser () {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    getUser () {
      const payload = {
        id: this.id
      }
      this.$store.dispatch('getUser', payload)
        .then((response) => {
          console.log('success', response.data)
          this.activeUserInfo = response.data
          setTimeout(() => {
            this.loadData()
          }, 1000)
        })
        .catch(error => {
          this.$vs.loading.close()
          console.log('error')
          console.log(error)
        })
      //this.loadData()
    },
    industryChanged (id) {
      this.industry = id.value
    },
    companyLogoUploaded (result) {
      this.company_logo = result
    },
    getPlaceDetails (place_id, callback) {

      const self = this
      this.placeService.getDetails({placeId: place_id}, function (PlaceResult, PlacesServiceStatus) {
        // PlaceResult is an object
        // PlacesServiceStatus is a string
        self.selectedPlace = PlaceResult
        console.log('places service status', PlacesServiceStatus)
        callback(PlaceResult)
      })
    },
    placesFound (value, deliver_to) {
      console.log('selected value', value, deliver_to)
      this.address_line1 = deliver_to
      this.state = value.terms[3].value
      this.city = value.terms[2].value
      const self = this
      this.getPlaceDetails(value.place_id, (PlaceResult) => {
        console.log('selected palce detail', PlaceResult)
        this.location = {
          type: 'Point',
          coordinates: [PlaceResult.geometry.location.lat(), PlaceResult.geometry.location.lng()]
        }
        console.log('location selected', this.location)
        self.zipcode = PlaceResult.address_components.filter(comp => comp.types.includes('postal_code'))[0].long_name
      })
    },
    placesFoundBilling (value, deliver_to) {
      console.log('selected value', value, deliver_to)
      this.billing_street = deliver_to
      this.billing_state = value.terms[3].value
      this.billing_city = value.terms[2].value

      const self = this
      this.getPlaceDetails(value.place_id, (PlaceResult) => {
        self.billing_zipcode = PlaceResult.address_components.filter(comp => comp.types.includes('postal_code'))[0].long_name
      })
    },
    loadData () {
      const {name, lastname, email, google_places, phone, company} = this.activeUserInfo
      this.name = name
      this.lastname = lastname
      this.email = email
      this.google_places = google_places
      this.phone = phone

      if (company) {
        this.company_name = company.name
        this.company_phone = company.phone
        this.website = company.website
        this.vat_number = company.vat_number
        this.industry = company.industry
        this.refreshIndustry = true
        if (company.logo) {
          this.company_logo = company.logo
        }
        if (company.address) {
          this.address_line1 = company.address.address_line1
          this.address_line2 = company.address.address_line2
          this.city = company.address.city
          this.state = company.address.state
          this.zipcode = company.address.zipcode
        }
        if (company.billing_address) {
          this.billing_street = company.billing_address.street
          this.billing_unit = company.billing_address.unit
          this.billing_zipcode = company.billing_address.zipcode
          this.billing_state = company.billing_address.state
          this.billing_city = company.billing_address.city

        }
      }
    },
    logout () {
      localStorage.removeItem('userInfo')
      localStorage.removeItem('accessToken')

      // This is just for demo Purpose. If user clicks on logout -> redirect
      this.$router.push('/login').catch(() => {})
    },
    updateCompanySettings () {
      const address = {
        address_line1: this.address_line1,
        address_line2: this.address_line2,
        city: this.city,
        state: this.state,
        zipcode: this.zipcode
      }

      const company = {
        name: this.company_name,
        vat_number: this.vat_number,
        phone: this.company_phone,
        website: this.website,
        industry: `${this.industry}`,
        address,
        logo: this.company_logo
      }
      const user = {
        id: this.activeUserInfo._id,
        company
      }
      this.$vs.loading()
      this.$store.dispatch('patchOtherUser', user)
        .then(result => {
          if (result) {
            console.log(result)
            this.$vs.notify({
              title: 'Success',
              text: 'Information saved successfully',
              color: 'success',
              iconPack: 'feather',
              icon: 'icon-check'
            })
            this.$vs.loading.close()
            this.getUser()
            this.refresh2 = true
          }
        })
        .catch(error => {
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
          this.$vs.loading.close()
        })
    },
    updateBillingSettings () {
      const address = {
        street: this.billing_street,
        unit: this.billing_unit,
        state: this.billing_state,
        city: this.billing_city,
        zipcode: this.billing_zipcode
      }

      const company = JSON.parse(JSON.stringify(this.activeUserInfo.company))
      company.billing_address = address
      const user = {
        id: this.activeUserInfo._id,
        company
      }
      this.$vs.loading()
      this.$store.dispatch('patchOtherUser', user)
        .then(result => {
          if (result) {
            console.log(result)
            this.$vs.notify({
              title: 'Success',
              text: 'Information saved successfully',
              color: 'success',
              iconPack: 'feather',
              icon: 'icon-check'
            })
            this.$vs.loading.close()
            this.getUser()
            this.refresh2 = true
          }
        })
        .catch(error => {
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
          this.$vs.loading.close()
        })
    },
    submitForm () {
      const user = {
        id: this.activeUserInfo._id,
        name: this.name,
        email: this.email,
        lastname: this.lastname,
        phone: this.phone
      }
      this.$vs.loading()
      console.log('patch user', user)
      this.$store.dispatch('patchOtherUser', user)
        .then(result => {
          if (result) {
            console.log(result)
            this.$vs.notify({
              title: 'Success',
              text: 'Information saved successfully',
              color: 'success',
              iconPack: 'feather',
              icon: 'icon-check'
            })
            this.getUser()
            this.$vs.loading.close()
          }
        })
        .catch(error => {
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
          this.$vs.loading.close()
        })
    }
  }
}
</script>
<style lang="scss">
</style>
